<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="loadData"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :single-expand="true"
                        @item-expanded="expandedEvent($event)"
                        item-key="documentFile.name"
                        show-expand
                        :loading="loading"
                        loading-text="Loading... Please wait"
                        class="elevation-1"
                        :options.sync="options"
                        :server-items-length="totalItems"
                >
                    <template v-slot:item.documentRule="{item}">
                        {{item.documentRule}}
                    </template>
                    <template v-slot:item.issueDate="{item}">
                        {{item.issueDate|formatDate}}
                    </template>
                    <template v-slot:item.expirationDate="{item}">
                        {{ (item.expirationDate == 'NONE' ? 'NONE' : $options.filters.formatDate(item.expirationDate)) }}
                    </template>
                    <template v-slot:item.status="{item}">
                        <v-chip class="mr-4"
                                :color="DOCUMENT_FILE_STATUS[item.status].color"
                                dark>{{ DOCUMENT_FILE_STATUS[item.status].text }}
                        </v-chip>
                    </template>

                    <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
                        <v-icon @click="expand(true)" v-if="item.documentFile !== 'NONE' && !isExpanded">mdi-chevron-down</v-icon>
                        <v-icon @click="expand(false)" v-if="item.documentFile !== 'NONE' && isExpanded">mdi-chevron-up</v-icon>
                    </template>
                    <!-- Inner table -->
                    <template v-slot:expanded-item="{ item, header }">
                        <td class="px-0" :colspan="headers.length">
                            <v-row>
                                <v-col cols="11" offset="1">
                                    <data-table
                                        :headers="headersInner"
                                        :fetchFunction="()=>getDataFromServerInnerTable"
                                        :tableId="selectedItem.id"
                                        ref="innerTable"
                                    >
                                        <template v-slot:item.status="{item}">
                                            <v-chip class="mr-4"
                                                    :color="DOCUMENT_FILE_STATUS[item.status].color"
                                                    dark>{{ DOCUMENT_FILE_STATUS[item.status].text }}
                                            </v-chip>
                                        </template>
                                        <!--actions-->
                                        <template v-slot:item.download="{item}">
                                            <file-download  :setDisabled="item.documentFile === 'NONE'"
                                                            :name="item.documentFile"
                                                            :belong-user-id="item.userId"
                                                            :setIcon="true"
                                            >
                                            </file-download>
                                        </template>
                                    </data-table>
                                </v-col>
                            </v-row>
                        </td>
                    </template>

                    <!--actions-->
                    <template v-slot:item.edit="{item}">
                        <!-- documentFile EDIT-->
                        <v-dialog v-model="docRuleDialog" persistent max-width="500">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on"
                                        color="success"
                                        class="mr-4"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                                <v-card>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Document Rule</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <doc-container :elevation="docFile.elevate? 4 : 0"
                                                       @click="docFile.elevate = !docFile.elevate"
                                                       :setDocumentRuleId="item.ruleId"
                                                       :userId="item.userId"
                                                       :ref="item.ruleId"
                                                       :setDocumentFile="item.documentFile"
                                                       :canReplaceDoc="true"
                                                       @document-changed = "docChange($event)"

                                                       :belong="id"
                                                       :document_type="DOCUMENT_FILE_TYPE.DOCUMENT"
                                                       :display_name="item.documentRule"
                                                       :created_by="getCreatedBy"
                                                       :entity_type="type.toUpperCase()"



                                                       :requiresApproval="item.approvalRequired"


                                        >

                                        </doc-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-row no-gutters justify-center>
                                            <v-col>
                                                <v-btn color="default" text @click="docRuleDialog = false">Cancel</v-btn>


                                                <v-btn color="primary" @click="saveDoc(item)">Save</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-card>
                        </v-dialog>
                    </template>
                    <template v-slot:item.download="{item}">
                        <file-download  :setDisabled="item.documentFile === 'NONE'"
                                        :name="item.documentFile.name"
                                       :belong-user-id="item.userId"
                                       :setIcon="true"
                        >
                        </file-download>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {DOCUMENT_GROUP_TYPES} from "@/shared/enums/DocumentGroup";
    import {USER_TYPE} from "@/shared/enums/UserType";
    import {DOCUMENT_FILE_STATUS} from "@/shared/enums/DocumentFile";
    const FileDownload = () => import ( '@/fileHandler/components/FileDownload');
    const DocContainer = () => import ('@/components/common/DocumentFilesContainer');
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    import DataTable from '@/components/common/DataTable';
    import FileHandler from "@/fileHandler/Handler";
    import {DOCUMENT_RULE_CONFIGURATIONS} from "@/shared/enums/DocumentRule";
    import {DOCUMENT_FILE_TYPE} from "@/shared/enums/DocumentFile";

    export default {
        name: "DocumentFileTable",
        props:["id", "type"],
        components:{FileDownload, DocContainer, responsiveButton, DataTable},
        data(){
            return{
                path_id: this.id,
                path_type: this.type,
                //docFile edit
                docFile:{
                    elevate: false,
                    documentFile:{},
                    documentRule:{},
                    userId:''
                },

                //main table
                headers:[
                    {   text: 'Document Rule',
                        value:'documentRule',
                        align: 'center',
                    },
                    {   text: 'Issue Date',
                        value: 'issueDate',
                        align: 'center'
                    },
                    {   text: 'Expiration Date',
                        value: 'expirationDate',
                        align: 'center'
                    },
                    {   text: 'Status',
                        value: 'status',
                        align: 'center',
                        divider: true,
                        width: '2%'
                    },
                    {   text: 'Edit',
                        value:'edit',
                        align: 'center',
                        sortable: false,
                        width: '2%'
                    },
                    {   text: 'Download',
                        value:'download',
                        align: 'center',
                        sortable: false,
                        width: '2%'
                    }
                ],
                items: [],
                expanded: [],
                singleExpand: true,
                loading: true,
                totalItems: 0,
                pagination: {},
                pageKeyCache: new Map(),
                options: {},
                docRuleDialog: false,
                /*
                  Inner table
                    */
                headersInner:[
                    {   text: 'Created Date',
                        value: 'systemCreatedDateTime',
                        align: 'center',
                        width:'30.5%'
                    },
                    {   text: 'Expiration Date',
                        value: 'expirationDate',
                        align: 'center',
                    },
                    /*for alignment*/
                    {   text: '',
                        value: 'forAlignmentWithParentTable',
                        align: 'center',
                    },
                    {   text: 'Status',
                        value: 'status',
                        align: 'center',
                        divider: true,
                        width: '2%'
                    },
                    {   text: 'Download',
                        value:'download',
                        align: 'center',
                        width: '2%'
                    },
                ],
                selectedItem: {},
                entity:{}
            }
        },
        watch:{
            id(value){
                this.path_id = value;
            },
            type(value){
                this.path_type = value;
            },
            options:{
                async handler () {
                    await this.loadData();
                },
                deep: true
            },
        },
        computed:{
            DOCUMENT_FILE_STATUS(){
                return DOCUMENT_FILE_STATUS;
            },
            DOCUMENT_FILE_TYPE(){
                return DOCUMENT_FILE_TYPE;
            },
            getCreatedBy(){
                if(this.isClient)
                    return this.id

                return this.$store.getters.getEmployee.cognitoUsername;

            },
            isClient(){
                return this.path_type == 'Client';
            },

        },
        methods:{
            async getDataFromServer(){
                this.loading = true;
                const { sortBy, descending, page, itemsPerPage } = this.options;

                let params = {
                    limit: itemsPerPage,
                    index: 'userId-systemUpdatedDate-index',
                    filter: 'and systemUpdatedDate <= :value',
                    value: (new Date()).toString()
                };

                if(this.pageKeyCache.has(page) && page !== 1){
                    params.lastEvaluatedKey = this.pageKeyCache.get(page);
                }
                else {
                    //we have not been there yet, so it needs to be to cases 1: this is brand new search page 0
                    // or it is the next page that we has not seem
                    if(page !== 1) {
                        params.lastEvaluatedKey = this.pageKeyCache.get(page-1);
                    }
                }

                let data = null;
                try {
                //    await this.$store.dispatch('getRequests', params);
                //    data = this.$store.getters.getRequests;
                    if(data === null){
                        throw  {message: 'Not data available!'};
                    }
                }
                catch (e) {
                    this.loading = false;
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.items = data;

                if(data.LastEvaluatedKey !== null) {
                    this.pageKeyCache.set(page, data.LastEvaluatedKey);
                    this.totalItems = data.length +1;
                }
                else{
                    this.totalItems = data.length;
                }

                this.loading = false;
            },
            async loadData(){
                this.loading = true;
                try {
                    //call store type
                    let getForType = 'get'+this.path_type;
                    await this.$store.dispatch(getForType, {id: this.path_id});
                    let object = this.$store.getters[getForType];
                    this.entity = this.$store.getters[getForType];
                    if(!object){
                        throw {message: `Not valid ${this.path_type} found for id: ${this.path_id}`};
                    }
                    //document already present
                    this.items = [];
                    for(let key in object.documentFiles)
                    {
                        let document = object.documentFiles[key]
                     //   await this.$store.dispatch('getDocumentFile', {id: document.file_id});
                     //   let docFromDb = this.$store.getters.getDocumentFile;
                        let item = {
                            documentRule: document.documentRule,
                            documentFile: document,
                            issueDate: document.issue_date,
                            userId: object.id,
                            ruleId: key,
                            fileId:  document.file_id,
                            expirationDate: !document.expiration_date? 'NONE' :document.expiration_date,
                            status: document.status
                        };

                        this.items.push(item);
                    }
                    //document not present
                    for(let key in object.documentGroups){
                        let group = object.documentGroups[key];
                        await this.$store.dispatch('getDocumentGroup', {id: group.id,type:DOCUMENT_GROUP_TYPES.DOCUMENT,applyTo: USER_TYPE.EMPLOYEE})
                        group = this.$store.getters.getDocumentGroup;
                        for(let keyDoc in group.documentRules){
                            let doc = group.documentRules[keyDoc];
                            let found = this.items.find(elem => doc.id == elem.ruleId);
                            if(found != undefined){
                                continue;
                            }
                            //not found, add to the list
                            let item = {
                                documentRule: doc.name,
                                ruleId: doc.id,
                                documentFile: 'NONE',
                                issueDate: 'NONE',
                                userId: 'NONE',
                                fileId:  'NONE',
                                expirationDate: 'NONE',
                                status: DOCUMENT_FILE_STATUS.INACTIVE.status
                            };
                            this.items.push(item);
                        }
                    }

                    this.totalItems = this.items.length;
                    this.loading = false;
                }
                catch (e) {
                    //set alert
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            getColorForActive(active){
                switch(active){
                    case DOCUMENT_FILE_STATUS.UP_TO_DATE.status:
                        return 'green';
                    default:
                        return 'red';
                }
            },
            async getDataFromServerInnerTable(itemParam){
                let params = {...itemParam,value: {':userId' : this.selectedItem.userId, ':ruleId': this.selectedItem.ruleId}};

                let documentFiles = null;
                try {
                       await this.$store.dispatch('getDocumentFiles', params);
                       documentFiles = this.$store.getters.getDocumentFiles;
                       if(documentFiles == null){
                            throw  {message: 'Not data available!'};
                       }
                }
                catch (e) {
                    this.loading = false;
                    this.$log.debug(e);
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                let data = {items: []};
                for(let document of documentFiles){
                    if(document.id === itemParam.fileId){
                        continue;
                    }

                    let item = {
                        documentFile: document.name,
                        systemCreatedDateTime: this.$options.filters.formatDate(document.systemCreatedDateTime),
                        userId: document.belongUser,
                        expirationDate: !document.expiredDate? 'NONE' :document.expiredDate,
                        status: document.status
                    };

                    data.items.push(item);
                }

                if(this.$store.getters.getDocumentFilesLastEvaluatedKey != null){
                    data.lastEvaluatedKey = this.$store.getters.getDocumentFilesLastEvaluatedKey;
                }

                return data;
            },
            docChange(documentFile){
                this.$log.debug(documentFile);
                this.docFile.documentFile = {...documentFile};
            },
            setDocFile(item){
                this.$log.debug('item: ', item);
                this.docFile.documentFile = item.documentFile;
                this.docFile.documentRule = item.documentRule;
                this.docFile.userId = item.userId;
            },
            expandedEvent(event){
                this.$log.debug('table inner expanded event : ', event);
                if(event.value) {
                    this.selectedItem = event.item;
                    if (this.$refs.innerTable != undefined)
                        this.$refs.innerTable.refresh(event.item.id);
                }
            },
            async saveDoc(oldDoc){
                if(this.docFile.documentFile.hasOwnProperty('file'))
                {
                    let metadata = {...this.docFile.documentFile.metadata};
                    metadata.issue_date = this.docFile.documentFile.issue_date;
                    if(this.docFile.documentFile.expiration_date !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.NO_EXPIRE_TEXT)
                        metadata.expiration_date = this.docFile.documentFile.expiration_date;
                    metadata.status = this.docFile.documentFile.status;
                    metadata.type = DOCUMENT_FILE_TYPE.DOCUMENT;
                    try {
                        await FileHandler.createFile('Document', this.docFile.documentFile.file, metadata);
                        this.docRuleDialog = false;

                        this.$store.dispatch('inactivateDocumentFiles', {
                            action: 'inactivated',
                            items:[
                                {
                                    documentRule: oldDoc.ruleId,
                                    id: oldDoc.fileId,
                                    notifyAdmin: true
                                }
                            ]
                        });

                        this.entity.documentFiles[oldDoc.ruleId] = {
                            documentRule: this.docFile.documentFile.documentRule,
                            issue_date: this.docFile.documentFile.issue_date,
                            file_id: this.docFile.documentFile.file_id,
                            name: this.docFile.documentFile.name,
                            status: this.docFile.documentFile.status
                        };

                        let setForType = 'set'+this.path_type;
                        await this.$store.dispatch(setForType, this.entity);
                        this.loadData();
                    }
                    catch (e) {
                        this.loading = false;
                        this.$log.debug(e);
                        alertEventBus.setAlert({type:'error', msg: e.message});
                        return;
                    }
                }
            }
        },
        async created(){
           // await this.getDataFromServer();
          //  await this.loadData();
        }
    }
</script>

<style scoped>

</style>